<template>
	<div class="hover-view">
		<div v-if="item" :class="['body', align]" :style="{
			gridTemplateColumns: gridTemplateColumns
		}">
			<div class="type" :style="{
				backgroundColor: types[item.type] ? types[item.type].color : 'black'
			}">
				<div class="label">{{ types[item.type] ? types[item.type].label : '' }}</div>
				<div class="tp">{{ item.hour_rate > 0 ? 'TP' : 'FP' }}</div>
			</div>
			<div class="label">
				{{ item.name }}
				<div class="num">
					#{{ item.num }}
				</div>
			</div>
			<div class="info">
				<table cellspacing="5" cellpadding="0">
					<tr>
						<td class="label">Ordrenummer</td>
						<td class="value">#{{ item.order_num | integer }}</td>
					</tr>
					<tr>
						<td class="sep" colspan="2"></td>
					</tr>
					<tr>
						<td class="label">Kundereference</td>
						<td class="value">{{ item.reference || '-' }}</td>
					</tr>
					<tr>
						<td class="sep" colspan="2"></td>
					</tr>
					<tr v-if="getSuperType(item.type) == 'survey'">
						<td class="label">Fra</td>
						<td class="value" v-html="norm(item.details?.address)"></td>
					</tr>
					<tr v-if="getSuperType(item.type) == 'survey'">
						<td class="label">Til</td>
						<td class="value" v-html="norm(item.details?.dest)"></td>
					</tr>
					<tr v-if="getSuperType(item.type) == 'move'">
						<td class="label">Fra</td>
						<td class="value" v-html="norm(item.details?.route[0])"></td>
					</tr>
					<tr v-for="(stop, i) in _via" :key="i">
						<td class="label">Via</td>
						<td class="value" v-html="stop"></td>
					</tr>
					<tr v-if="getSuperType(item.type) == 'move'">
						<td class="label">Til</td>
						<td class="value" v-html="norm(item.details?.route[item.details?.route.length  - 1])"></td>
					</tr>
					<tr v-if="getSuperType(item.type) != 'survey' && getSuperType(item.type) != 'move'">
						<td class="label">Adresse</td>
						<td class="value" v-html="norm(item.details?.address)"></td>
					</tr>
					<tr>
						<td class="sep" colspan="2"></td>
					</tr>
					<tr>
						<td class="label">Ankomst</td>
						<td v-if="item.date_type == 'default' || !item.date_type" class="value">{{ item.from.time | timestamp }} - {{ item.from.time2 | extractTime }}</td>
						<td v-if="item.date_type == 'any'" class="value">{{ item.from.time | date }}, Vi bestemmer ankomst</td>
						<td v-if="item.date_type == 'unknown'" class="value">Ukendt dato</td>
					</tr>
					<tr>
						<td class="label">Omfang</td>
						<td class="value" v-html="norm(item.secondary)"></td>
					</tr>
					<tr>
						<td class="label">Type</td>
						<td class="value" v-html="norm(item.details?.type)"></td>
					</tr>
					<tr>
						<td class="sep" colspan="2"></td>
					</tr>
					<tr>
						<td class="label">Telefon</td>
						<td class="value">{{ norm(item.phone) }}</td>
					</tr>
					<tr>
						<td class="label">E-mail</td>
						<td class="value">{{ norm(item.email) }}</td>
					</tr>
					<tr>
						<td class="sep" colspan="2"></td>
					</tr>
					<tr>
						<td class="label">Bemærkninger</td>
						<td class="value" style="font-weight: normal;">{{ norm(item.remarks) }}</td>
					</tr>
					<!--
					<tr>
						<td class="sep" colspan="2"></td>
					</tr>
					<tr>
						<td class="label">Ordre pris</td>
						<td class="value">{{ item.order_total | number }}</td>
					</tr>
					<tr>
						<td class="label">Fakturerede timer</td>
						<td class="value">{{ item.inv_hours | number }}</td>
					</tr>
					<tr>
						<td class="sep" colspan="2"></td>
					</tr>
					<tr>
						<td class="label">Ordre kostpris</td>
						<td class="value">{{ item.order_cost | number }}</td>
					</tr>
					<tr>
						<td class="sep" colspan="2"></td>
					</tr>
					<tr>
						<td class="label">Opgave kostpris</td>
						<td class="value">{{ item.task_cost | number }}</td>
					</tr>
					<tr>
						<td class="sep" colspan="2"></td>
					</tr>
					<tr>
						<td class="label">Dækningsbidrag</td>
						<td class="value">{{ (item.order_total - item.order_cost) | number }}</td>
					</tr>
					<tr>
						<td class="label">Dækningsgrad</td>
						<td class="value">{{ item.order_total == 0 ? (item.order_cost == 0 ? 0 : -100) : (((item.order_total - item.order_cost) * 100) / item.order_total) | number }} %</td>
					</tr>
					-->
					<tr>
						<td class="sep" colspan="2"></td>
					</tr>
					<tr>
						<td class="label">Afdeling</td>
						<td class="value">{{ departments[item.department_id] ? departments[item.department_id].label : '-' }}</td>
					</tr>
					<tr>
						<td class="label">Ansvarlig</td>
						<td class="value">{{ employees[item.employee_id] ? employees[item.employee_id].name : '-' }}</td>
					</tr>
					<tr>
						<td class="label">Oprettet af</td>
						<td class="value">{{ employees[item.creator_employee_id] ? employees[item.creator_employee_id].name : '-' }}</td>
					</tr>
					<tr>
						<td class="label">Planlagt af</td>
						<td v-if="item.planned_employee_ids.length == 0" class="value">-</td>
						<td v-else class="value">
							<div style="font-size: 14px;" v-for="(emp, i) in item.planned_employee_ids" :key="i">
								{{ employees[emp.employee_id] ? employees[emp.employee_id].name : '-' }}<br>
								<span class="planned-date">{{ emp.created | timestamp }}</span>
							</div>
						</td>
					</tr>
					<tr>
						<td class="sep" colspan="2"></td>
					</tr>
					<tr>
						<td class="label">Containere</td>
						<td class="value">{{ item.containers ? (item.containers.length == 0 ? 'Ingen' : item.containers.join(', ')) : 'Ingen' }}</td>
					</tr>
					<tr>
						<td class="sep" colspan="2"></td>
					</tr>
					<tr>
						<td class="label">Skadesag</td>
						<td class="value">{{ item.claim_status }}</td>
					</tr>
				</table>
			</div>
			<div class="dyn team" v-for="(team, i) in _teams" :key="i">
				<div class="title">Hold {{ i }}</div>
				<div class="block">
					<div class="title">Køretøjer</div>
					<div v-if="team.vehicles.length == 0" class="desc">-</div>
					<div class="desc" v-for="(v, a) in team.vehicles" :key="a">{{ v.driver ? v.name + ' (' + v.driver + ')' : v.name }}</div>
				</div>
				<div class="block">
					<div class="title">Medarbejdere</div>
					<div v-if="team.employees.length == 0" class="desc">-</div>
					<div class="desc grid" v-for="(v, a) in team.employees" :key="a">
						<div class="status" :style="{
							backgroundColor: colors[v.status]
						}"></div>
						<div class="name">{{ v.name }}</div>
						<div :class="{ hours: true, approved: v.hours_appr }">{{ v.hours | roundHours | formatHours }}</div>
					</div>
					<div class="desc grid" style="border-top: 1px solid #ddd; margin-top: 5px;">
						<div class="status" style="opacity: 0;"></div>
						<div class="name">Total</div>
						<div class="hours">{{ team.hours_total | formatHours }}</div>
					</div>
					<div v-if="false" class="desc grid" style="">
						<div class="status" style="opacity: 0;"></div>
						<div class="name">Faktureret</div>
						<div class="hours">{{ totalHours(team.employees) | formatHours }}</div>
					</div>
				</div>
				<div class="title" style="padding-top: 20px;">Tidligere kørt af</div>
				<div class="block">
					<div class="title">Seneste 5 kørt for kunden</div>
					<div v-if="!item.latest || item.latest.length == 0" class="desc">-</div>
					<div class="desc" v-for="(v, a) in item.latest ? item.latest : []" :key="a">
						<div class="name">{{ v.name }}</div>
					</div>
				</div>
				<div v-if="item.store !== null" class="block">
					<div class="title">Til lager</div>
					<div v-if="!item.store || item.store === null" class="desc">-</div>
					<div class="desc" v-for="(v, a) in !item.store || item.store === null ? [] : item.store.employees" :key="a">
						<div class="name">{{ v.name }}</div>
					</div>
				</div>
			</div>
			<div class="dyn instr">
				<div class="title">Instruktioner</div>
				<div v-if="Object.keys(extractObj(item.details?.route, 'instructions')) == 0" class="block">-</div>
				<div v-else class="block">
					<div class="stop" v-for="(stop, i) in item.details?.route.filter(s => 'instructions' in s && Object.keys(s.instructions).length > 0) || []" :key="i">
						<div class="address">{{ stop.address }}</div>
						<div class="instruction" v-for="(instr, i) in stop.instructions" :key="i">
							<div class="title">{{ instructions[i] ? instructions[i].label : '-' }}</div>
							<div v-if="instr" class="desc">{{ instr }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="dyn instr" style="padding-right: 20px; width: 300px;">
				<div class="title">Seneste 5 registreringer</div>
				<div v-if="item.registrations.length == 0" class="block">-</div>
				<div v-for="(reg, i) in item.registrations" :key="i" class="block">
					<div class="title">{{ reg.name }}</div>
					<div class="table">
						<div class="header">
							<div class="cell" style="white-space: nowrap;">{{ {
								pickup: 	'Afhentning',
								deliver: 	'Levering',
								waive: 		'Eftergivet'
							}[reg.action] }}</div>
							<div class="cell" style="text-align: right;">{{ reg.created | timestamp }}</div>
						</div>
						<div v-for="(prod, j) in reg.products" :key="j" class="row">
							<div class="cell" style="white-space: nowrap;">{{ prod.label }}</div>
							<div class="cell" style="text-align: right;">{{ prod.qty }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="dyn instr" style="padding-right: 20px; width: 300px;">
				<div class="title">Emballage status</div>
				<div class="pack-item" v-for="(pack, i) in item.pack" :key="i">
					<div class="product">{{ pack.label }}</div>
					<div class="qty">{{ pack.qty }}</div>
				</div>
			</div>
			<div class="dyn instr">
				<div class="title">Bemærkninger</div>
				<div v-if="item.comments.length == 0" class="block">-</div>
				<div v-for="(comm, i) in item.comments" :key="i" class="block">
					<div class="title">{{ comm.name }}</div>
					<div class="desc">{{ comm.message }}</div>
				</div>
			</div>
		</div>
		<div v-if="value && !item" :class="['body', 'spinner', align]">
			<spinner-view />
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				colors: {
					in: '#00c017',
					out: '#f7223f'
				},
				abortController: null,
				item: null
			};
		},
		props: {
			value: {
				type: Object,
				default: null
			},
			align: {
				type: String,
				default: 'left'
			},
			types: {
				type: Object,
				default() {
					return {};
				}
			},
			employees: {
				type: Object,
				default() {
					return {};
				}
			},
			departments: {
				type: Object,
				default() {
					return {};
				}
			},
			instructions: {
				type: Object,
				default() {
					return {};
				}
			}
		},
		watch: {
			value: {
				handler(n) {
					const self = this;

					if (n === null) {
						this.item = null;
					} else {
						if (!n.full) {
							// Load meta
							(async () => {
								self.abortController = new AbortController();

								const data = (await this.axios.get(`/tasks/${n.id}/meta`, {
									signal: self.abortController.signal
								})).data;

								self.item = { ...self.value, ...data };
							})();
						} else {
							// Meta present
							this.item = n;
						}
					}
				},
				immediate: true
			},
			types(n) {
				
			}
		},
		methods: {
			getSuperType(type) {
				return type in this.$store.getters.tasks ? this.$store.getters.tasks[type].super : type;
			},
			totalHours(emps) {
				const self = this;

				return emps.reduce((acc, emp) => {
					return acc + self.$options.filters.roundHours(emp.buf_time);
				}, 0);
			},
			norm(data, data2) {
				var d = data ? (typeof data === 'object' ? '-' : data) : '-';

				if (data && data.address) {
					d = `${data.address}<br>${data.zip} ${data.city}, ${data.country}<br>`;

					if (data.elevator) d += `<div class="tag">Elevator</div>`;
					if (data.lift) d += `<div class="tag">Møbellift</div>`;
					if (data.floors && data.floors != '') d += `<div class="tag">${data.floors} ETA</div>`;
					if (data.distance && data.distance != '') d += `<div class="tag">${data.distance} MTB</div>`;

					return d;
				}

				d = data ? (typeof data === 'object' ? '-' : data) : '-';

				if (typeof data2 != 'undefined') {
					d += ', ' + data2;
				}

				return d.length > 256 ? d.substr(0, 256) + '...' : d;
			},
			extractObj(data, name) {
				var r  = {};

				if (data) {
					for (var i = 0; i < data.length; ++i) {
						if (data[i][name]) {
							for (var n in data[i][name]) {
								r[n] = data[i][name][n];
							}
						}
					}
				}

				return r;
			}
		},
		computed: {
			_teams() {
				const self = this;
				var r = [];

				
				

				for (var i in this.item.status.bookings) {
					var total = 0;
					var team = this.item.status.bookings[i];

					team.employees = team.employees.map((emp) => {
						const hr 		= self.item.hours.union.find((item) => { return item.employee_id == emp.id; });

						emp.hours 		= hr ? parseFloat(hr.hours) : 0;
						emp.hours_appr 	= hr ? hr.approved : 0;

						total 			+= parseFloat(hr ? hr.hours : 0);

						return emp;
					});

					team.hours_total = total;

					r.push(team);
				}

				return r;
			},
			_via() {
				

				if (this.getSuperType(this.item.type) == 'move' && this.item.details.route.length > 2) {
					var r = [];

					for (var i = 1; i < this.item.details.route.length - 1; ++i) {
						r.push(this.norm(this.item.details.route[i]));
					}

					

					return r;
				} else {
					

					return [];
				}
			},
			gridTemplateColumns() {
				var cols = ['30px', 'auto'];

				

				if (this.item) {
					for (var i in this.item.status.bookings) {
						cols.push('auto');
					}
				}

				cols.splice(cols.length - 2, 0, 'auto auto auto auto [semi]');

				return cols.join(' ') + ' [end]';
			}
		},
		destroyed() {
			if (this.abortController !== null) {
				this.abortController.abort();
				this.abortController = null;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.hover-view {
		pointer-events: none;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 1000000;

		.planned-date {
			font-size: 12px;
			font-weight: normal;
			color: gray;
		}

		& .pack-item {
			margin-top: 10px;
			display: grid;
			grid-template-columns: auto auto;
			line-height: 24px;
			border-bottom: 1px solid rgb(233, 233, 233);

			& > .qty {
				text-align: right;
			}
		}

		& > .body {
			&.left {
				left: 20px;
			}

			&.right {
				right: 20px;
			}

			background-color: white;
			border-radius: 5px;
			overflow: hidden;
			position: absolute;
			bottom: 20px;
			display: grid;
			grid-template-rows: auto 1fr 20px;
			z-index: 1000000;

			-webkit-box-shadow: 2px 2px 12px -6px rgba(0,0,0,1);
			-moz-box-shadow: 2px 2px 12px -6px rgba(0,0,0,1);
			box-shadow: 2px 2px 12px -6px rgba(0,0,0,1);

			& > .type {
				color: white;
				font-weight: bold;
				grid-column: 1;
				grid-row: 1 / 4;
				position: relative;

				& > .label {
					position: absolute;
					bottom: 0;
					left: 30px;
					line-height: 30px;
					font-size: 12px;
					white-space: nowrap;
	
					transform: rotate(-90deg);
					transform-origin: bottom left;
					padding-left: 10px;
				}

				& > .tp {
					position: absolute;
					top: 0;
					left: 30px;
					line-height: 30px;
					font-size: 12px;
	
					transform: rotate(-90deg);
					transform-origin: bottom left;
					padding-right: 10px;
				}
			}

			& > .label {
				grid-column: 2 / end;
				grid-row: 1;
				padding: 20px;
				font-size: 16px;
				font-weight: bold;

				& > .num {
					float: right;
					font-size: 16px;
					font-weight: bold;
				}
			}

			& > .info {
				padding: 0 30px 0 20px;
				max-width: 500px;
				
				& > table td {
					vertical-align: top;
					font-size: 14px;

					::v-deep .tag {
						display: inline-block;
						background-color: #f7223f;
						font-size: 12px;
						color: white;
						padding: 3px 5px 3px 5px;
						border-radius: 3px;
						margin-top: 4px;
						margin-bottom: 6px;
						margin-right: 3px;
					}

					&.label {
						padding-right: 20px;
					}

					&.value {
						font-weight: bold;
					}

					&.sep {
						height: 10px;
					}
				}
			}

			& > .dyn {
				border-left: 1px solid #e9e9e9;
				padding: 0 50px 0 20px;

				&.team {
					padding-right: 20px;
				}

				&.instr {
					max-width: 300px;
				}

				& > .title {
					font-weight: bold;
				}

				& > .block {
					padding-top: 10px;
					width: 100%;

					& > .stop {
						padding-bottom: 8px;

						& > .address {
							font-size: 12px;
							font-weight: bold;
							padding: 0 0 3px 0;
							margin: 0 0 3px 0;
							border-bottom: 1px solid #e9e9e9;
						}

						& > .instruction {
							margin-top: 5px;
							

							& > .title {
								
							}

							& > .desc {
								margin-top: 3px;
								font-size: 14px;
								color: gray;
								font-style: italic;
							}
						}
					}

					& > .title {
						font-size: 14px;
						font-weight: bold;
						margin-bottom: 3px;
					}

					& > .table {
						display: grid;
						grid-template-columns: 1fr;

						& > .header {
							display: grid;
							grid-template-columns: 50px 1fr;
							border-bottom: 1px solid rgb(199, 199, 199);

							& > .cell {
								font-size: 14px;
								line-height: 20px;
							}
						}

						& > .row {
							display: grid;
							grid-template-columns: 50px 1fr;

							& > .cell {
								font-size: 14px;
								line-height: 20px;
							}
						}
					}

					& > .desc {
						padding-top: 5px;
						font-size: 14px;
						
						&.grid {
							display: grid;
							grid-template-columns: 20px 1fr 100px;
							width: 100%;
							align-items: center;
						}

						& > .hours {
							/*background-color: yellow;*/
							text-align: right;

							&.approved {
								color: #00bd00 ! important;
							}
						}

						& > .status {
							width: 6px;
							height: 6px;
							border-radius: 50%;
						}
					}
				}
			}

			&.spinner {
				display: block;
				padding: 30px;
			}
		}
	}
</style>